var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLogout = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 16 16",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "m12.167 4.667-1.175 1.175 1.316 1.325H5.5v1.666h6.808l-1.316 1.317 1.175 1.183L15.5 8l-3.333-3.333Zm-10-2.5H8V.5H2.167C1.25.5.5 1.25.5 2.167v11.666c0 .917.75 1.667 1.667 1.667H8v-1.667H2.167V2.167Z"
})));
export default SvgLogout;